import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Tooltip as ReactTooltip } from "react-tooltip";
import firebase from "firebase/compat/app";
import AuditLogTable from "./AuditLogTable";
import { Element, scroller } from "react-scroll";

const Chapter1_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);
  const location = useLocation(); 
  const questions = [
    {
      question: "Frage 1: Welche drei Elemente gehören zur CIA-Triade?",
      options: [
        {
          value: "A",
          label: "Verlässlichkeit, Datenschutz, Verschlüsselung",
        },
        {
          value: "B",
          label: "Vertraulichkeit, Integriät, Verfügbarkeit",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Wie unterstützt die Integrität in der CIA-Triade die Datensicherheit?",
      options: [
        {
          value: "A",
          label:
            "Sie gewährleistet, dass Daten nur durch autorisierte Personen geändert werden können und unbeschädigt bleiben.",
        },
        {
          value: "B",
          label:
            "Durch Integrität wird der fahrlässige oder vorsätzliche Datenverlust verhindert.",
        },
      ],
      correct: "A",
    },
  ];
  
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 1_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "1_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("1_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 1_3.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "1_3",
              completedChapters: ["1_3"],
            });
          console.log("Dokument erstellt mit Kapitel 1_3.");
        }

        navigate("/cybersecurity/1_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };

  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  Was ist Cybersecurity?
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Die CIA-Triade
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 1: Was ist Cybersecurity?</h3>
          <h2 className="text-center p-3">Die CIA-Triade</h2>
          <img
            src="/images/cia.webp"
            alt="cia"
            style={{ position: "relative", maxWidth: "15%", height: "auto" }}
          />
        </div>

        <div className="chapter p-5 text-center">
          <h2 className="p-5">Was sind die Ziele der Cybersecurity?</h2>
          <p className="col-lg-11 mx-auto">
            Wir wissen bereits, dass Cybersecurity dazu dient, Computersysteme,
            Netzwerke und Daten vor unbefugtem Zugriff und Angriffen zu
            schützen. Aber warum ist es so wichtig, diese Daten gezielt zu
            schützen?
          </p>
          <p className="col-lg-11 mx-auto bg-light text-start p-5 m-5 text-decoration-none  rounded-2">
            Eine Bank muss sicherstellen, dass deine Kontodaten{" "}
            <ul>
              <li>
                <strong>vertraulich</strong> bleiben (niemand darf sie
                einsehen),
              </li>
              <li>
                die Daten<strong> korrekt/integriert </strong>bleiben (niemand
                darf den Kontostand manipulieren){" "}
              </li>
              <li>
                und dass du als Kunde immer Zugriff auf dein Onlinekonto hast
                (die <strong> Verfügbarkeit </strong>muss gewährleistet sein).
              </li>
            </ul>
          </p>
          <p className="col-lg-11 mx-auto bg-light text-start p-5 m-5 text-decoration-none  rounded-2">
            Im Krankenhaus müssen Patientendaten{" "}
            <ul>
              <li>
                <strong>vertraulich </strong>
                behandelt werden (nur Ärzte und Krankenschwestern dürfen sie
                sehen),
              </li>
              <li>
                <strong>integriert</strong> bleiben (die Diagnose oder
                Behandlung darf nicht manipuliert werden){" "}
              </li>
              <li>
                und <strong>immer verfügbar </strong>
                sein (die Systeme müssen im Notfall zugänglich sein).
              </li>
            </ul>
          </p>
          <p className="col-lg-11 mx-auto">
            Diese drei Prinzipien{" "}
            <strong>Vertraulichkeit, Integrität und Verfügbarkeit</strong> (
            <strong>C</strong>onfidentiality, <strong>I</strong>ntegrity,{" "}
            <strong>A</strong>vailability) legen fest, wie wir Informationen
            schützen. Sie sind die Grundlage jeder Sicherheitsstrategie,
            unabhängig von technologischen Entwicklungen oder spezifischen
            Bedrohungen, denen Unternehmen heute gegenüberstehen.
            <br />
            <br />
            Die
            <strong>CIA-Triade </strong> wurde bereits 1970 entwickelt. Das
            älteste und grundlegendsten Modell der Cybersecurity hat trotz der
            enormen technologischen Entwicklungen über Jahrzehnte hinweg nichts
            an Relevanz verloren. Die Prinzipien Vertraulichkeit, Integrität und
            Verfügbarkeit bilden immer noch das Fundament jeder
            Sicherheitsstrategie. Jedes dieser Elemente erfüllt eine spezifische
            Funktion, die für die Sicherstellung von Daten in einer digitalen
            Welt unerlässlich ist.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container">
          <div className="p-5 text-center">
            <h2 className="p-5">Vertraulichkeit (Confidentiality)</h2>
            <h4 className="pb-5">Schutz der Privatsphäre</h4>
            <p className="pb-5 col-lg-11 mx-auto">
              Vertraulichkeit bedeutet, dass sensible Informationen nur für
              diejenigen zugänglich sind, die die entsprechende Berechtigung
              haben. Unbefugter Zugriff auf diese Daten muss also verhindert
              werden. Ob es sich um persönliche Daten von Kunden,
              Geschäftsgeheimnisse oder Regierungsinformationen handelt – es ist
              entscheidend, dass diese Daten nur von autorisierten Benutzern
              eingesehen werden können.
              <br />
              <br />
              In vielen Branchen, wie z. B. dem Gesundheitswesen oder dem
              Finanzsektor, ist die Vertraulichkeit aufgrund gesetzlicher
              Vorschriften wie der
              <strong> DSGVO (Datenschutz-Grundverordnung) </strong> besonders
              kritisch. In der EU gilt die DSGVO für alle Unternehmen. Sie
              fordert den Schutz der Vertraulichkeit personenbezogener Daten.
              Unternehmen müssen sicherstellen, dass Kundendaten nur für
              festgelegte Zwecke verarbeitet werden und vor unbefugtem Zugriff
              geschützt sind. Ein Verstoß gegen die Vertraulichkeit, wie etwa
              ein{" "}
              <span
                data-tooltip-id="tooltip-data"
                data-tooltip-content="Ein Datenleck ist ein Vorfall, bei dem vertrauliche oder sensible Informationen ungewollt an die Öffentlichkeit oder unbefugte Personen gelangen. Dies kann durch Sicherheitslücken, menschliche Fehler, Hackerangriffe oder ungesicherte Systeme geschehen und kann dazu führen, dass persönliche Daten, Finanzinformationen, Geschäftsdaten oder andere schützenswerte Informationen offengelegt werden. Datenlecks stellen ein großes Risiko für die Privatsphäre und die Sicherheit der Betroffenen dar."
                className="custom-tooltip-trigger"
              >
                {" "}
                Datenleck{" "}
              </span>{" "}
              (Data Breach) oder der unbefugte Zugriff auf vertrauliche
              Informationen, kann erhebliche rechtliche und finanzielle
              Konsequenzen haben.
              <br />
              <br />
              Um die Vertraulichkeit zu gewährleisten, werden verschiedene
              Sicherheitsmaßnahmen eingesetzt, darunter:
              <br />
              <br />
              <strong>Zugriffskontrollen: </strong>
              Nur autorisierte Benutzer erhalten Zugriff auf bestimmte Systeme
              oder Daten. Durch Zugriffskontrollmechanismen wird geregelt, wer
              auf welche Daten zugreifen darf. Diese Mechanismen umfassen
              Maßnahmen wie Benutzerauthentifizierung und Rechteverwaltung.
              Mitarbeiter sollten auch nur Zugriff auf die Daten erhalten, die
              sie für ihre Arbeit wirklich benötigen.
              <br />
              <br />
              <strong>Verschlüsselung: </strong>
              Eine der effektivsten Maßnahmen ist die Verschlüsselung der Daten
              sowohl bei der Speicherung als auch bei der Übertragung. Moderne
              Verschlüsselungsalgorithmen stellen sicher, dass die Daten nur mit
              dem richtigen Schlüssel lesbar sind. Selbst wenn ein Angreifer an
              die verschlüsselten Daten gelangt, sind diese ohne den Schlüssel
              unbrauchbar für ihn.
              <br />
              Du wirst später noch mehr über die Verschlüsselung erfahren.
              <br />
              <br />
              <strong>Physische Sicherheit: </strong>
              Vertrauliche Daten und Systeme müssen vor unbefugtem physischen
              Zugriff geschützt werden, z. B. durch Zutrittskontrolle zu
              Serverräumen, abschließbare Schränke oder die sichere Aufbewahrung
              von Datenträgern.
              <br />
              <br />
              <strong>Mitarbeitersensibilisierung: </strong>
              Mitarbeiter müssen im Umgang mit vertraulichen Informationen
              geschult und sensibilisiert werden. Sie sollten die Bedeutung der
              Vertraulichkeit verstehen, Sicherheitsrichtlinien kennen und
              wissen, wie sie Daten schützen können.
            </p>
            <ReactTooltip
              id="tooltip-data"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>
      </div>
      <div className="gelb-section">
        <div className="p-5 col-lg-9 mx-auto text-center">
          <h2 className="p-5">Integrität (Integrity)</h2>

          <h4 className="pb-5">Verlässlichkeit der Daten</h4>
          <p className="pb-5 col-lg-11 mx-auto">
            Integrität der Daten bedeutet, dass Daten korrekt und vollständig
            bleiben und nicht unbemerkt verändert werden können – weder während
            der Speicherung noch während der Übertragung. Daten dürfen nur durch
            autorisierte Personen oder Prozesse verändert werden und alle
            Veränderungen müssen nachvollziehbar sein.
            <br />
            <br />
            Ein Verstoß gegen die Integrität kann schwerwiegende Folgen haben.
            Wenn Daten ohne Erlaubnis geändert oder manipuliert werden, können
            Entscheidungen auf falschen Informationen basieren, was zu
            finanziellen Verlusten, Betriebsstörungen oder sogar Gefahren für
            die öffentliche Sicherheit führen kann. Beispielsweise könnten die
            Manipulation von Gesundheitsdaten in einem Krankenhaus zu falschen
            Behandlungen oder die Änderung von Finanzdaten in einem Unternehmen
            zu erheblichen Verlusten führen.
            <br />
            <br />
            Zu den häufig genutzten Maßnahmen zur Sicherstellung der Integrität
            gehören:
            <br />
            <br />
            <strong>Datenvalidierung: </strong> Datenvalidierung ist ein
            Prozess, bei dem überprüft wird, ob eingegebene Daten korrekt,
            vollständig und im richtigen Format sind, bevor sie
            weiterverarbeitet oder gespeichert werden. Zum Beispiel wird bei
            einer E-Mail-Adresse geprüft, ob sie das „@“-Zeichen enthält, oder
            bei einer Zahl, ob sie wirklich vollständig numerisch eingeben ist.
            Damit wird sichergestellt, dass nur gültige und konsistente Daten in
            Datenbanken und Systeme eingegeben werden. So werden Fehler oder
            ungewollte Manipulationen verhindert.
            <br />
            <br />
            <br />
            <Element name="hashing">
              <strong>Hashing:</strong> Spezielle Hashing-Algorithmen verwandeln
              ein Passwort, eine Nachricht oder eine ganze Datei von beliebiger
              Größe in eine hexadezimale Zeichenfolge von fester Länge, die als
              Hash bezeichnet wird. Das Hashing ist irreversibel. Die
              Zeichenfolge (der Hash), kann also niemals wieder in die
              ursprüngliche Form zurückverwandelt werden. Cloud-Speicherdienste
              und Datenbankmanagementsysteme verfügen meist über automatische
              Hash-Prüfungen, um Datenintegrität sicherzustellen und
              Manipulationen oder Übertragungsfehler zu erkennen.
              <br />
              <br />
              Wenn eine Datei in einen Hash-Wert umgewandelt und dieser Hash
              zusammen mit der Datei gesendet wird, kann der Empfänger
              überprüfen, ob die Datei während des Versands unverändert
              geblieben ist. Der Hash ist also so etwas wie eine "Prüfsumme":
            </Element>
            <section class="p-5 text-start">
              <h5 className="p-3">So funktioniert Hashing</h5>
              <ul class="timeline">
                <li class="timeline-item mb-5">
                  <h5 class="fw-semibold">
                    1. Hash-Erstellung vor dem Versand:
                  </h5>

                  <p>
                    Der Absender berechnet den Hash-Wert der Originaldatei und
                    sendet ihn (entweder zusammen mit der Datei oder separat) an
                    den Empfänger.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-semibold">2. Hash-Überprüfung beim Empfang:</h5>

                  <p>
                    Der Empfänger berechnet erneut den Hash-Wert der empfangenen
                    Datei.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-semibold">3. Vergleich der Hash-Werte:</h5>

                  <p>
                    Der empfangene Hash-Wert wird mit dem neu berechneten
                    verglichen. Sind beide identisch, ist die Datei unverändert
                    und vollständig angekommen. Unterscheiden sie sich, deutet
                    das auf eine Veränderung der Datei während des Transports
                    hin.
                  </p>
                </li>
              </ul>
            </section>
            <strong>Digitale Signaturen:</strong> Digitale Signaturen sind eine
            Art elektronische „Unterschrift“, die sicherstellt, dass digitale
            Nachrichten oder Dokumente authentisch und unverändert sind. Sie
            basieren auf{" "}
            <span
              data-tooltip-id="tooltip-krypt"
              data-tooltip-content="Kryptografie ist die Wissenschaft und Technik der Verschlüsselung von Informationen, um sie vor unbefugtem Zugriff zu schützen. Sie verwandelt lesbare Daten in unleserliche Zeichenfolgen, die nur mit einem speziellen Schlüssel wieder entschlüsselt werden können, und stellt so Vertraulichkeit, Integrität und Authentizität von Daten sicher. Du wirst später noch mehr zur Kryptografie erfahren."
              className="custom-tooltip-trigger"
            >
              {" "}
              Kryptografie{" "}
            </span>{" "}
            und garantieren dem Empfänger, dass die Nachricht tatsächlich vom
            Absender stammt und während der Übertragung nicht manipuliert wurde.
            Besonders wichtig sind digitale Signaturen bei bedeutenden oder
            diskreten Transaktionen, Vertragsabschlüssen oder wichtigen E-Mails,
            da sie Vertrauen und Sicherheit im digitalen Austausch schaffen.{" "}
            <br />
            <br />
            <section class="pt-5 text-start">
              <h5 className="p-3">So funktioniert eine digitale Signatur</h5>
              <ul class="timeline">
                <li class="timeline-item mb-5">
                  <h5 class="fw-semibold">1. Erstellung der Signatur:</h5>

                  <p>
                    Der Absender nutzt seinen{" "}
                    <strong>privaten Schlüssel, </strong> um einen einzigartigen
                    Code (die Signatur) zu erzeugen, der mit den Daten des
                    Dokuments verknüpft ist. Nur der Absender hat Zugriff auf
                    diesen privaten Schlüssel. Daher kann auch nur er die
                    Signatur erstellen.
                  </p>
                </li>

                <li class="timeline-item mb-5">
                  <h5 class="fw-semibold">2. Verifizierung:</h5>

                  <p>
                    Der Empfänger nutzt den{" "}
                    <strong>öffentlichen Schlüssel </strong> des Absenders, um
                    die Signatur zu prüfen. Wenn die Signatur gültig ist,
                    bestätigt dies, dass die Daten unverändert sind und wirklich
                    vom Absender stammen.
                  </p>
                </li>
              </ul>
            </section>
            Der öffentliche Schlüssel ist für jeden zugänglich, der die
            Identität des Absenders überprüfen möchte. Er wird in öffentlichen
            Schlüsseldatenbanken oder Zertifikaten gespeichert und ist frei
            verfügbar. Der private Schlüssel bleibt dagegen geheim beim
            Absender. So bleibt der Prozess sicher: Nur der Absender kann eine
            Signatur erstellen, aber jeder mit dem öffentlichen Schlüssel kann
            die Authentizität und Integrität der Nachricht überprüfen.
            <br />
            <br /> <br />
            <br />
            <strong>Versionskontrollen: </strong>Sie verfolgen Änderungen an
            Dateien oder Dokumenten, indem jede neue Version gespeichert wird.
            Dadurch kann man jederzeit frühere Versionen wiederherstellen und
            sehen, wer welche Änderungen vorgenommen hat. Versionskontrollen
            sind besonders nützlich bei der Entwicklung von Dokumenten, wenn
            Änderungen häufig und von mehreren Personen vorgenommen werden.
            <br />
            <br />
            <br />
            <br />
            <strong>Audit-Logs: </strong> Sie dokumentieren detailliert, wer
            wann und von wo auf Daten zugegriffen oder Änderungen vorgenommen
            hat. Durch diese lückenlose Möglichkeit der Nachverfolgung lassen sich unbefugte
            Zugriffe und Manipulationen schnell erkennen und untersuchen, da
            Audit-Logs selbst gegen Manipulation geschützt sind. Dies sorgt
            dafür, dass sensible Daten im System zuverlässig überwacht werden.
            <br />
            <br />
            Außerdem erfüllen Audit-Logs wichtige Compliance-Anforderungen und
            Sicherheitsstandards wie{" "}
            <span
              data-tooltip-id="tooltip-dsgvo"
              data-tooltip-content="Die DSGVO (Datenschutz-Grundverordnung) ist ein EU-Gesetz, das den Schutz persönlicher Daten regelt. Es legt fest, wie Unternehmen und Organisationen Daten sicher speichern, verarbeiten und vor Cyberangriffen schützen müssen."
              className="custom-tooltip-trigger"
            >
              {" "}
              DSGVO{" "}
            </span>{" "}
            oder{" "}
            <span
              data-tooltip-id="tooltip-hipa"
              data-tooltip-content="HIPAA (Health Insurance Portability and Accountability Act) ist ein US-amerikanisches Gesetz, das den Schutz sensibler Gesundheitsdaten vorschreibt. Es legt fest, wie medizinische Informationen sicher gespeichert, übertragen und vor unbefugtem Zugriff geschützt werden müssen."
              className="custom-tooltip-trigger"
            >
              {" "}
              HIPA,{" "}
            </span>{" "}
            die eine umfassende Protokollierung fordern. Moderne Systeme bieten
            sogar Echtzeit-Überwachung und Alarme bei verdächtigen Aktivitäten,
            sodass sofort auf Bedrohungen reagiert werden kann. Im Falle eines
            Sicherheitsvorfalls liefern Audit-Logs zudem wertvolle
            Informationen, um die Ursache zu analysieren und künftige Vorfälle
            zu verhindern.
            <AuditLogTable />
            Ein Audit-Log besteht typischerweise aus einer Liste von Einträgen,
            die jede Aktion im System detailliert dokumentieren. Jeder Eintrag
            enthält oft Informationen wie Benutzer-ID, Datum und Uhrzeit der
            Aktion, Art der Aktion (z. B. „Login“, „Dateiänderung“, „Zugriff
            verweigert“), die betroffenen Dateien oder Daten und manchmal auch
            den Ursprung (z. B. IP-Adresse oder Gerät).
          </p>
          <ReactTooltip
            id="tooltip-krypt"
            place="top"
            className="custom-tooltip"
          />
          <ReactTooltip
            id="tooltip-dsgvo"
            place="top"
            className="custom-tooltip"
          />
          <ReactTooltip
            id="tooltip-hipa"
            place="top"
            className="custom-tooltip"
          />
        </div>
      </div>

      <div className="white-section">
        <div className="p-5 col-lg-9 mx-auto text-center">
          <h2 className="p-5">Verfügbarkeit (Availability)</h2>
          <h4 className="pb-5 text-center ">Zugriff, wenn es nötig ist </h4>
          <p className="col-lg-11 mx-auto">
            Verfügbarkeit bedeutet, dass berechtigte Benutzer jederzeit auf die
            Informationen und Systeme zugreifen können, wenn sie diese
            benötigen. Ein System, das zwar sicher, aber nicht zugänglich ist,
            erfüllt seine Aufgabe nicht. Ausfälle und Unterbrechungen müssen
            daher unbedingt minimiert werden. Verfügbarkeit ist entscheidend für
            die kontinuierliche Geschäftstätigkeit und den Betrieb kritischer
            Infrastrukturen.
            <br />
            <br />
            Bedrohungen der Verfügbarkeit sind vielfältig und können durch
            Cyberangriffe entstehen, bei denen Systeme durch eine Überlastung
            von Anfragen lahmgelegt werden. Aber auch interne Probleme wie
            Hardwareausfälle oder Naturkatastrophen können die Verfügbarkeit
            beeinträchtigen. <br />
            <br />
            Maßnahmen, die zur Sicherstellung der Verfügbarkeit beitragen, sind
            unter anderem:
            <br />
            <br />
          </p>
          <p className="col-lg-9 text-start mx-auto">
            <ul>
              <li>
                <strong>
                  Redundante und ausfallsichere Systemarchitekturen und
                  Netzwerke:
                  <br />
                </strong>{" "}
                Redundanz bedeutet in diesem Zusammenhang, dass wichtige
                Komponenten (wie Server, Festplatten, Netzwerkknoten) mehrfach
                vorhanden sind. Fällt eine Komponente aus, kann eine identische
                Komponente die Funktion sofort übernehmen, sodass der Betrieb
                ununterbrochen weiterläuft.
                <br />
                <br />
                Ausfallsichere Systemarchitekturen setzen eine
                unterbrechungsfreie Stromversorgung und Klimatisierung von
                Rechenzentren voraus. Durch die Kombination von mehreren
                redundanten Systemen wird sichergestellt, dass keine einzige
                Störung zu einem Totalausfall führt. Diese Systeme verwenden
                Technologien wie automatische Failover-Mechanismen, die beim
                Ausfall einer Komponente sofort auf eine andere umschalten.
                <br />
                <br />
                Zusätzlich werden geografisch verteilte Rechenzentren genutzt,
                um auch bei größeren Störungen, wie z. B. Naturkatastrophen, den
                Zugriff auf die Daten zu gewährleisten. <br />
                <br /> Zusammen ermöglichen diese Maßnahmen eine hohe
                Verfügbarkeit. Sie schützen Unternehmen vor Datenverlust und
                Ausfallzeiten, die kostspielig und geschäftsschädigend sein
                können.
              </li>
              <br />
              <br />
              <li>
                <strong>Datensicherungen: </strong>
                <br />
                Backups sind ein zentraler Bestandteil der Verfügbarkeit und
                spielen eine entscheidende Rolle, um den Zugriff auf Daten auch
                bei Systemausfällen, Datenverlust oder Cyberangriffen zu
                gewährleisten. Ein Backup ist eine Sicherungskopie wichtiger
                Daten, die regelmäßig erstellt und sicher an einem anderen Ort
                gespeichert wird. Backups sind ein elementarer Bestandteil der
                Cybersecurity. Das so genannte "Backup-Management" umfasst alle
                Prozesse zur Sicherstellung regelmäßiger, zuverlässiger
                Datensicherungen, wie z. B. die Festlegung von
                Backup-Strategien, die Automatisierung von Sicherungsprozessen
                und die Überprüfung der Wiederherstellbarkeit. Du wirst später
                noch mehr über das Backup-Management erfahren.
              </li>
              <br />
              <br />
              <li>
                <strong>Disaster-Recovery-Pläne: </strong>
                <br />
                Diese Pläne helfen Unternehmen, nach einem Vorfall wie einem
                Cyberangriff oder einem Hardwareausfall schnell wieder in den
                Normalbetrieb zurückzukehren. Auf dieses wichtige Element der
                Cybersecurity werden wir später noch eingehen.
              </li>
            </ul>
          </p>
          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            In der Praxis müssen Vertraulichkeit, Integrität und Verfügbarkeit
            immer gegeneinander abgewogen werden. Oft erhöhen Maßnahmen, die dem
            einem Aspekt dienen, die Risiken für einen anderen. Aufgabe des
            Sicherheitsmanagements ist es, hier die richtige Balance zu finden.
            Ein System, das perfekt die Vertraulichkeit schützt, aber nicht
            verfügbar ist, nützt wenig. Ebenso ist eine hohe Verfügbarkeit
            sinnlos, wenn die Integrität der Daten nicht gewährleistet ist. Ein
            robustes Cybersecurity-Management muss daher alle drei Aspekte
            berücksichtigen.
          </p>{" "}
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter1_3;
